<div class="registration-entry-card">
  <div class="registration-entry-card__body">
    <strong class="registration-entry-card__title">{{ title }}</strong>
    <div class="registration-entry-card__meta" *ngIf="meta">
      <span [attr.dir]="metaDir">{{ meta }}</span>
    </div>
  </div>

  <div class="registration-entry-card__actions">
    <ng-content select="[extraActions]"></ng-content>

    <button mat-icon-button type="button" *ngIf="showEdit" [matTooltip]="editTooltip" (click)="edit.emit()">
      <mat-icon>edit</mat-icon>
    </button>

    <button mat-icon-button type="button" [matTooltip]="deleteTooltip" (click)="delete.emit()" [disabled]="!canDelete">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <div class="registration-entry-card__footer" [class.registration-entry-card__footer--start]="footerStartOnly">
    <ng-content select="[footerStart]"></ng-content>
    <ng-content select="[footerBadge]"></ng-content>
  </div>
</div>
